import JwtDecode from 'jwt-decode'
import Axios from './axios_wrapper'

export function getUserToken(data) {
  return Axios({
    url: '/auth/identity/callback',
    method: 'POST',
    data
  })
}

// TODO: is this needed?
export function getAuthUser(token) {
  const decoded = JwtDecode(token);

  return Axios({
    url: `/users/${decoded.sub}`,
    method: 'GET'
  })
}

export function logout(token) {
  return Axios({
    url: '/auth/revoke',
    method: 'DELETE',
    data: {
      token
    }
  })
}

export function getAvailableRoles() {
  return Axios({
    url: `/users/registrations`,
    method: 'GET'
  })
}

export function getAllUsers(page) {
  return Axios({
    url: `/users`,
    method: 'GET',
    page
  })
}

export function getUsersByRole(page, role) {
  return Axios({
    url: `/users?role=${role}`,
    method: 'GET',
    page
  })
}

export function getUsersByRoleAdmin(page, role) {
  return Axios({
    url: `/admin/users?role=${role}`,
    method: 'GET',
    page
  })
}

export function getUsersByRoleDistributor(page, role) {
  return Axios({
    url: `/distributor/users?role=${role}`,
    method: 'GET',
    page
  })
}

export function getUsersByRoleHospitalAdmin(page, role) {
  return Axios({
    url: `/hospital_admin/users?role=${role}`,
    method: 'GET',
    page
  })
}

export function getUserByEmail(page, email) {
  return Axios({
    url: `/users?email=${encodeURIComponent(email)}`,
    method: 'GET',
    page
  })
}

export function getPatientByEmail(email) {
  return Axios({
    url: `/patients?filter=${encodeURIComponent(email)}`,
    method: 'GET'
  })
}

export function updateUser(userUuid, data) {
  return Axios({
    url: `/users/${userUuid}`,
    method: 'PATCH',
    data
  })
}

export function updateProfile({ userUuid, data }) {
  return Axios({
    url: `/users/${userUuid}/profile`,
    method: 'PATCH',
    data
  })
}

export function getUser(id) {
  return Axios({
    url: `/users/${id}`,
    method: 'GET'
  })
}

export function getUserDetails(id) {
  return Axios({
    url: `/admin/users/${id}`,
    method: 'GET'
  })
}

export function createUser(data) {
  return Axios({
    url: `/users`,
    method: 'POST',
    data
  })
}

export function deletePatient(id) {
  return Axios({
    url: `/patients/${id}`,
    method: 'DELETE'
  })
}

export function deletePatientOwn({userId}) {
  return Axios({
    url: `/users/${userId}/accounts`,
    method: 'DELETE'
  })
}

export function activateUser({ id }) {
  return Axios({
    url: `/users/${id}/activation`,
    method: 'PATCH'
  })
}

export function deactivateUser({ id }) {
  return Axios({
    url: `/users/${id}/deactivation`,
    method: 'PATCH'
  })
}

export function paswordResetUpdate({ resetToken, data }) {
  return Axios({
    url: `/users/password_reset/${resetToken}`,
    method: 'PATCH',
    data
  })
}

export function paswordResetUpdateEmail({ data }) {
  return Axios({
    url: `/users/password_reset`,
    method: 'POST',
    data
  })
}

export function updatePassword({id, data}) {
  return Axios({
    url: `/users/${id}/password`,
    method: 'PATCH',
    data
  })
}

export function deleteUser({ id }) {
  return Axios({
    url: `/users/${id}`,
    method: 'DELETE'
  })
}

export function getPatientOperation(userId, patientId, page) {
  return Axios({
    url: `/users/${userId}/operations?patient_id=${patientId}`,
    method: 'GET',
    page
  })
}

export function getPatients(page) {
  return Axios({
    url: `/patients`,
    method: 'GET',
    page
  })
}

export function getPatient(id) {
  return Axios({
    url: `/patients/${id}`,
    method: 'GET'
  })
}

export function getPatientHistory(id) {
  return Axios({
    url: `/patients/${id}/history`,
    method: 'GET'
  })
}

export function updatePatient(userUuid, data) {
  return Axios({
    url: `/patients/${userUuid}`,
    method: 'PATCH',
    data
  })
}

export function getPatientByFilter(email) {
  return Axios({
    url: `/patients?filter=${email}`,
    method: 'GET'
  })
}

export function createPatient(data) {
  return Axios({
    url: `/patients`,
    method: 'POST',
    data
  })
}

export function createSurgeon({ data }) {
  return Axios({
    url: `/surgeons`,
    method: 'POST',
    data
  })
}

export function getAssociatedNurses({userId}) {
  return Axios({
    url: `/users/${userId}/nurses`,
    method: 'GET'
  })
}

export function getAssociatedSurgeons({userId}) {
  return Axios({
    url: `/users/${userId}/surgeons`,
    method: 'GET'
  })
}

export function getAssociatedSurgeonsForHospitalAdmin() {
  return Axios({
    url: `/hospital_admin/surgeons`,
    method: 'GET'
  })
}

// TODO: Change URL to nurses instead of surgeons, both here and on API
export function addNurseToSurgeon({userId, nurseId, data}) {
  return Axios({
    url: `/users/${userId}/surgeons/${nurseId}`,
    method: 'PATCH',
    data
  })
}

export function getNurseByEmail(email, noPagination) {
  const url = noPagination ? `/users?role=nurse&email=${email}&partial_match=false&no_pagination=true`
                           : `/users?role=nurse&email=${email}&partial_match=false`

  return Axios({
    url: url,
    method: 'GET'
  })
}
// TODO: Change URL to nurses instead of surgeons, both here and on API
export function removeNurseFromSurgeon({userId, nurseId}) {
  return Axios({
    url: `/users/${userId}/surgeons/${nurseId}`,
    method: 'DELETE'
  })
}

export function addHospitalToSurgeon({userId, hospitalId}) {
  return Axios({
    url: `/users/${userId}/user_hospitals/${hospitalId}`,
    method: 'PATCH'
  })
}

export function removeHospitalFromSurgeon({userId, hospitalId}) {
  return Axios({
    url: `/users/${userId}/user_hospitals/${hospitalId}`,
    method: 'DELETE'
  })
}

export function createUserHospitals({ id, hospitalId }) {
  return Axios({
    url: `/users/${id}/user_hospitals/${hospitalId}`,
    method: 'PATCH'
  })
}

export function deleteUserHospitals({ id, hospitalId }) {
  return Axios({
    url: `/users/${id}/user_hospitals/${hospitalId}`,
    method: 'DELETE'
  })
}

export function getUserHospitals({ id, page }) {
  return Axios({
    url: `/users/${id}/user_hospitals`,
    method: 'GET',
    page
  })
}

export function getUserHospitalsByCountries({ id }, countries) {
  return Axios({
    url: `/users/${id}/user_hospitals${countries}`,
    method: 'GET'
  })
}

export function getDefaultHospital({ userId }) {
  return Axios({
    url: `/users/${userId}/default_hospital`,
    method: 'GET'
  })
}

export function createDistributor(data) {
  return Axios({
    url: `/admin/distributors`,
    method: 'POST',
    data
  })
}

export function updateDistributor(id, data) {
  return Axios({
    url: `/admin/distributors/${id}`,
    method: 'PATCH',
    data
  })
}

export function createHospitalAdmin(data) {
  return Axios({
    url: `/admin/hospital_admin`,
    method: 'POST',
    data
  })
}

export function updateHospitalAdmin(userUuid, data) {
  console.log('updateHospitalAdmin', data);
  
  return Axios({
    url: `/admin/hospital_admin/${userUuid}`,
    method: 'PATCH',
    data
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/users.js
// module id = null
// module chunks = 